export class InsuranceDocumentFileTypeResultDto {
    fileType: string;
    fileTypeCode: string;
    requiresExpirationDate: string;
}
